export default class AddController {
  constructor(CouponsDataProvider, $state) {
    "ngInject"
    this.CouponsDataProvider = CouponsDataProvider;
    this.$state = $state;
  }

  create(form) {
    if (!form) {
      return false;
    }
    let
      vm = this;
    vm.CouponsDataProvider.createCoupon(vm.coupon).then(function (res) {
      if (res.exist == '1') {
        vm.existRecord = 1;
      }
      else {
        vm.$state.go('app.couponlisting');
      }
    })

  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/coupons/components/add/controller.js
 **/